import React, { useState, useEffect, useRef } from 'react';
import {
  Row,
  Col,
  Checkbox,
  Button,
  Typography,
  Space,
  Dropdown,
  Menu,
  Modal,
  Form,
  Input,
  Select,
  DatePicker,
  Tooltip,
} from 'antd';
import {
  CaretDownOutlined,
  CaretRightOutlined,
  MoreOutlined,
} from '@ant-design/icons';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import httpInjectorService from 'services/http-injector.service';
import Cookies from 'js-cookie';
import utc from 'dayjs/plugin/utc';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import '../pages/BacklogPage.css';
import { useSelector } from 'react-redux';
import { useFetchBacklogData } from 'views/admin/taskManagement/BackLogPage/Alldata';

dayjs.extend(utc);

const { Title, Text } = Typography;
const { confirm } = Modal;

const SprintHeader = ({
  title,
  taskCount,
  sprint,
  collapsed,
  onCollapseToggle,
  allSelected,
  onSelectAll,
  onDelete,
  onComplete,
  projectId,
  fetchBacklogData,
  isOpen,
  sprintCounts,
}) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isCompleteModalVisible, setIsCompleteModalVisible] = useState(false);
  const [startMode, setStartMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isSprintStarted, setIsSprintStarted] = useState(taskCount > 0);
  //const [incompleteTasks, setIncompleteTasks] = useState([]);
  const [sprintList, setSprintList] = useState([]);
  const [selectedFutureSprint, setSelectedFutureSprint] = useState(null);
  const [activeSprints, setActiveSprints] = useState([]);
  const [futureSprints, setFutureSprints] = useState([]);
  const [taskSummary, setTaskSummary] = useState({
    completed: 0,
    open: 0,
  });
  const [goalValue, setGoalValue] = useState('');
  const [showQuill, setShowQuill] = useState(false);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [showFullGoal, setShowFullGoal] = useState(false);

  //const { fetchBacklogData } = useFetchBacklogData(projectId);
  // console.log(fetchBacklogData,'all the data from header')
  //const sprintss = useSelector(state => state.Authentication.backlogdata)
  //console.log('sprintss in sprint header',sprint)

  // sprint.forEach(sp=>{
  //     console.log("Sprint Name:", sp.name);
  // console.log("Status:", sp.status);
  // console.log("Tasks:", sp.tasks);
  // })

  const actionBtnRef = useRef(null);
  const roleId = Number(Cookies.get('task-role-id'));

  useEffect(() => {
    if (!dropdownVisible) return;

    const observer = new window.IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) {
          setDropdownVisible(false);
        }
      },
      { threshold: 0 },
    );

    if (actionBtnRef.current) {
      observer.observe(actionBtnRef.current);
    }
    return () => observer.disconnect();
  }, [dropdownVisible]);

  const [form] = Form.useForm();
  const {
    start_date,
    end_date,
    sprint_id,
    project_id,
    tasks,
    sprint_goal,
    days_left,
  } = sprint;

  const showEditModal = (isStart = false) => {
    setStartMode(isStart);
    form.setFieldsValue({
      name: title,
      startDate: sprint?.start_date ? dayjs(sprint.start_date) : null,
      endDate: sprint?.end_date ? dayjs(sprint.end_date) : null,
      goal: sprint.sprint_goal || '',
    });

    setIsModalVisible(true);
  };

  useEffect(() => {
    if (isModalVisible) {
      setTimeout(() => {
        form.setFieldsValue({
          name: sprint?.name,
          startDate: sprint?.start_date ? dayjs(sprint.start_date) : null,
          endDate: sprint?.end_date ? dayjs(sprint.end_date) : null,
          goal: sprint?.sprint_goal || '',
        });
      }, 50);
    }
  }, [isModalVisible]);

  const handleStartSprint = async () => {
    const taskIds = sprint?.tasks?.map((task) => task.id) || [];

    if (!taskIds.length) {
      toast.error('Sprint cannot be started without any tasks.');
      return;
    }

    try {
      const values = await form.validateFields();

      const payload = {
        project_id: projectId,
        sprint_id,
        sprint_name: values.name,
        start_date: dayjs(values.startDate).format('YYYY-MM-DD'),
        end_date: dayjs(values.endDate).format('YYYY-MM-DD'),
        ...(values.goal ? { sprint_goal: values.goal.trim() } : {}),
        tasks: taskIds,
      };

      setLoading(true);

      const res = await httpInjectorService.taskStartSprint(payload);

      if (res?.status === 'success') {
        toast.success(res.message || 'Sprint started successfully.');
        setIsSprintStarted(true);
        await fetchBacklogData();
      } else {
        toast.error(res?.message || 'Failed to start sprint.');
      }
    } catch (err) {
      toast.error(err.message || 'Validation failed.');
    } finally {
      setLoading(false);
      setIsModalVisible(false);
    }
  };

  const handleUpdateSprint = async () => {
    try {
      const values = await form.validateFields();

      const payload = {
        sprint_id,
        sprint_name: values.name,
        start_date: dayjs(values.startDate).format('YYYY-MM-DD'),
        end_date: dayjs(values.endDate).format('YYYY-MM-DD'),
        project_id: projectId,
        ...(values.goal ? { sprint_goal: values.goal.trim() } : {}),
      };

      setLoading(true);

      const res = await httpInjectorService.taskUpdateSprint(payload);

      if (res?.status === 'success') {
        toast.success(res.message || 'Sprint updated successfully.');
        setIsModalVisible(false);
        await fetchBacklogData();
      } else {
        toast.error(res?.message || 'Failed to update sprint.');
      }
    } catch (err) {
      toast.error(err.message || 'Validation failed.');
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteSprint = async () => {
    try {
      const payload = {
        project_id: projectId,
        sprint_id: sprint.sprint_id,
      };

      const res = await httpInjectorService.deleteSprint(payload);

      if (res?.status === 'success') {
        toast.success(res.message || 'Sprint deleted successfully');
        onDelete?.();
        await fetchBacklogData();
      } else {
        toast.error(res.message || 'Failed to delete sprint');
      }
    } catch (err) {
      toast.error('Error deleting sprint');
      console.error(err);
    }
  };

  // update getsprintlist to ONLY fetch & return
  const getsprintlist = async () => {
    try {
      const response = await httpInjectorService.getsprintList(projectId);
      if (response.status === 'success') {
        return response.data;
      } else {
        return { active_sprints: [], future_sprints: [] };
      }
    } catch (error) {
      console.error('Error fetching sprint list:', error);
      return { active_sprints: [], future_sprints: [] };
    }
  };

  useEffect(() => {
    if (isOpen) {
      getsprintlist();
    }
  }, [isOpen]);

  const handleCompleteClick = async () => {
    setLoading(true);
    try {
      // 1. Fetch sprint summary
      const queryParams = `?sprint_id=${sprint.sprint_id}&project_id=${projectId}`;
      const response = await httpInjectorService.getSprintTaskSummary(
        queryParams,
      );

      if (response.status === 'success') {
        setTaskSummary({
          completed: Number(response.data.completed_items) || 0,
          open: Number(response.data.open_items) || 0,
        });
      } else {
        setTaskSummary({ completed: 0, open: 0 });
      }

      // 2. Fetch sprints
      const sprintRes = await getsprintlist();

      const { future_sprints = [] } = sprintRes || {};

      // Exclude current sprint
      const validFuture = future_sprints.filter(
        (s) => String(s.sprint_id) !== String(sprint.sprint_id),
      );

      // Build dropdown options
      const options = [{ label: 'Backlog', value: 0 }];
      validFuture.forEach((s) => {
        options.push({ label: s.sprint_name, value: s.sprint_id });
      });

      setSprintList(options);

      setIsCompleteModalVisible(true);
    } catch (error) {
      console.error(error);
      toast.error('Failed to fetch sprint summary or sprint list.');
    } finally {
      setLoading(false);
    }
  };

  const handleCompleteSprint = async () => {
    try {
      setLoading(true);

      const payload = {
        project_id: projectId,
        sprint_id: sprint.sprint_id,
        target_sprint_id: selectedFutureSprint,
      };

      const response = await httpInjectorService.completeSprint(payload);

      if (response?.status === 'success') {
        toast.success(response.message || 'Sprint completed successfully.');
        setIsCompleteModalVisible(false);
        setSelectedFutureSprint(null);
        await fetchBacklogData();
      } else {
        toast.error(response.message || 'Failed to complete sprint.');
      }
    } catch (error) {
      console.error(error);
      toast.error('Error completing the sprint.');
    } finally {
      setLoading(false);
    }
  };

  const showDeleteSprintConfirm = () => {
    confirm({
      title: 'Are you sure you want to delete this sprint?',
      content: 'All tasks inside this sprint will be moved back to backlog.',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        handleDeleteSprint();
      },
    });
  };

  const startDate = Form.useWatch('startDate', form);
  const endDate = Form.useWatch('endDate', form);

  useEffect(() => {
    if (isModalVisible && sprint) {
      setGoalValue(sprint.sprint_goal || '');
      setShowQuill(false);

      form.setFieldsValue({
        name: sprint.name,
        startDate: sprint.start_date ? dayjs(sprint.start_date) : null,
        endDate: sprint.end_date ? dayjs(sprint.end_date) : null,
      });
    }
  }, [isModalVisible]);

  const menu = (
    <Menu>
      <Menu.Item key="edit" onClick={() => showEditModal(false)}>
        Edit
      </Menu.Item>
      <Menu.Item key="delete" onClick={showDeleteSprintConfirm}>
        Delete
      </Menu.Item>
    </Menu>
  );

  const getStatusStyle = (status) => {
    const s = status.toUpperCase();

    if (s === 'DONE' || s === 'COMPLETED') {
      return {
        background: '#e6fffb',
        color: '#08979c',
        border: '1px solid #87e8de',
      };
    }

    if (s === 'TO DO') {
      return {
        background: '#f5f5f5',
        color: '#595959',
        border: '1px solid #d9d9d9',
      };
    }

    return {
      background: '#e6f4ff',
      color: '#1677ff',
      border: '1px solid #91caff',
    };
  };

  const StatusBadges = ({ byStatus }) => {
    if (!byStatus) return null;

    return (
      <div style={{ display: 'flex', gap: 6 }}>
        {Object.entries(byStatus).map(([status, count]) => (
          <Tooltip key={status} title={status}>
            <span
              style={{
                minWidth: 24,
                height: 24,
                padding: '0 6px',
                borderRadius: 4,
                fontSize: 13,
                fontWeight: 500,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'default',
                ...getStatusStyle(status),
              }}
            >
              {count}
            </span>
          </Tooltip>
        ))}
      </div>
    );
  };
  const sprintMeta = sprintCounts?.find(
    (s) => s.sprint_id === sprint.sprint_id,
  );

  return (
    <>
      <Row
        style={{
          marginBottom: 16,
          padding: '12px 16px 6px 16px',
          background: '#fafafa',
          border: '1px solid #f0f0f0',
          borderRadius: 8,
          display: 'flex',
          flexDirection: 'column',
          gap: 6,
        }}
      >
        {/* FIRST ROW — TITLE + DATES + BUTTONS */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            flexWrap: 'wrap',
            gap: 12,
          }}
        >
          {/* LEFT SIDE */}
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Button
              type="text"
              icon={collapsed ? <CaretRightOutlined /> : <CaretDownOutlined />}
              onClick={onCollapseToggle}
              style={{ padding: 0, marginRight: 12 }}
            />

            <div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 12,
                  flexWrap: 'wrap',
                }}
              >
                <Title level={5} style={{ margin: 0 }}>
                  {title}
                </Title>

                <Text type="secondary">
                  {start_date ? start_date.format('DD MMM') : '-'} –{' '}
                  {end_date ? end_date.format('DD MMM') : '-'}
                </Text>

                <Text type="secondary">({taskCount} work items)</Text>

                {days_left && (
                  <Text type={days_left <= 3 ? 'danger' : 'success'}>
                    {days_left > 0 ? `${days_left} days left` : 'Sprint ended'}
                  </Text>
                )}
              </div>
            </div>
          </div>

          {/* RIGHT SIDE —  BUTTONS */}
          <Space align="center" wrap>
            {sprintMeta && <StatusBadges byStatus={sprintMeta.byStatus} />}
            {[1, 2].includes(roleId) && (
              <>
                {sprint.status === 'Planned' && (
                  <Button
                    style={{ backgroundColor: '#722ed1', color: 'white' }}
                    onClick={() => showEditModal(true)}
                    disabled={sprint.tasks.length === 0}
                  >
                    Start Sprint
                  </Button>
                )}

                {sprint.status === 'In Progress' && (
                  <Button
                    style={{ backgroundColor: '#722ed1', color: 'white' }}
                    onClick={handleCompleteClick}
                  >
                    Complete Sprint
                  </Button>
                )}

                <Dropdown
                  overlay={menu}
                  trigger={['click']}
                  visible={dropdownVisible}
                  onVisibleChange={setDropdownVisible}
                >
                  <Button icon={<MoreOutlined />} ref={actionBtnRef} />
                </Dropdown>
              </>
            )}
          </Space>
        </div>

        {/* SECOND ROW — SPRINT GOAL */}
        {Boolean(sprint_goal?.trim()) && (
          <div style={{ width: '100%' }}>
            {/* TEXT */}
            <div
              style={{
                color: '#696969',
                fontSize: 13,
                lineHeight: '18px',
                display: '-webkit-box',
                WebkitLineClamp: showFullGoal ? 'unset' : 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
              }}
            >
              <div
                dangerouslySetInnerHTML={{
                  __html: sprint_goal,
                }}
              />
            </div>

            {/* MORE / LESS BUTTON ALWAYS BELOW TEXT */}
            <div style={{ marginTop: 4, textAlign: 'left' }}>
              {!showFullGoal ? (
                <Button
                  type="link"
                  style={{ padding: 0 }}
                  onClick={() => setShowFullGoal(true)}
                >
                  More
                </Button>
              ) : (
                <Button
                  type="link"
                  style={{ padding: 0 }}
                  onClick={() => setShowFullGoal(false)}
                >
                  Less
                </Button>
              )}
            </div>
          </div>
        )}
      </Row>

      {/* Edit / Start Modal */}
      <Modal
        title={startMode ? `Start sprint: ${title}` : `Edit sprint: ${title}`}
        open={isModalVisible}
        onOk={startMode ? handleStartSprint : handleUpdateSprint}
        onCancel={() => setIsModalVisible(false)}
        okText={startMode ? 'Start Sprint' : 'Update'}
        confirmLoading={loading}
        okButtonProps={{
          style: { backgroundColor: '#722ed1', color: 'white' },
          disabled: !startDate || !endDate,
        }}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            label="Sprint name"
            name="name"
            rules={[{ required: true, message: 'Sprint name is required' }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Start date"
            name="startDate"
            rules={[{ required: true, message: 'Start date required' }]}
          >
            <DatePicker style={{ width: '50%' }} format="DD MMM YYYY" />
          </Form.Item>

          <Form.Item
            label="End date"
            name="endDate"
            rules={[{ required: true, message: 'End date required' }]}
          >
            <DatePicker style={{ width: '50%' }} format="DD MMM YYYY" />
          </Form.Item>

          <Form.Item label="Sprint goal">
            {!showQuill ? (
              <Input.TextArea
                placeholder="Click to edit sprint goal"
                value={goalValue?.replace(/<[^>]+>/g, '')}
                onClick={() => setShowQuill(true)}
                autoSize={{ minRows: 3, maxRows: 3 }}
              />
            ) : (
              <ReactQuill
                theme="snow"
                value={goalValue}
                onChange={(value) => {
                  setGoalValue(value);
                  form.setFieldsValue({ goal: value });
                }}
                style={{ height: 80, marginBottom: 30 }}
              />
            )}
            <Form.Item name="goal" noStyle>
              <Input type="hidden" />
            </Form.Item>
          </Form.Item>
        </Form>
      </Modal>

      {/* Complete Sprint Modal */}
      <Modal
        title={`Complete ${title}`}
        open={isCompleteModalVisible}
        onCancel={() => setIsCompleteModalVisible(false)}
        footer={[
          <Button key="cancel" onClick={() => setIsCompleteModalVisible(false)}>
            Cancel
          </Button>,
          <Button
            key="complete"
            style={{ backgroundColor: '#722ed1', color: 'white' }}
            onClick={handleCompleteSprint}
            loading={loading}
            disabled={
              loading ||
              (taskSummary.open > 0 && selectedFutureSprint === undefined)
            }
          >
            Complete sprint
          </Button>,
        ]}
      >
        <div style={{ textAlign: 'center', marginBottom: 16 }}>
          <img
            src="https://img.icons8.com/fluency/48/prize.png"
            alt="trophy"
            style={{ marginBottom: 8 }}
          />
          <Typography.Title level={5}>
            This sprint has <b>{taskSummary.completed} completed</b> and{' '}
            <b>{taskSummary.open} open</b> tasks.
          </Typography.Title>
        </div>

        {taskSummary.open > 0 && (
          <>
            <Typography.Text>
              Move the <b>{taskSummary.open}</b> open tasks to:
            </Typography.Text>
            <Select
              style={{ width: '100%', marginTop: 8 }}
              placeholder="Select future sprint or Backlog"
              value={selectedFutureSprint}
              onChange={(value) => setSelectedFutureSprint(value)}
            >
              {sprintList &&
                sprintList.map((s) => (
                  <Select.Option key={String(s.value)} value={s.value}>
                    {s.label}
                  </Select.Option>
                ))}
            </Select>
          </>
        )}
      </Modal>
    </>
  );
};

export default SprintHeader;
